import * as React from "react"
export const Svg_019 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M29.5 24.984a1.976 1.976 0 1 0 0-3.952 1.976 1.976 0 0 0 0 3.952Z"
      />
      <path
        fill="url(#c)"
        d="M29.502 55.543 45.77 39.277c8.97-8.97 8.97-23.567 0-32.538A22.857 22.857 0 0 0 29.5 0a22.857 22.857 0 0 0-16.269 6.74c-8.97 8.97-8.97 23.566 0 32.537l16.266 16.266H0V59h59v-3.457H29.502ZM15.417 23.008c0-7.766 6.318-14.083 14.083-14.083 7.766 0 14.083 6.317 14.083 14.083 0 7.765-6.317 14.083-14.083 14.083-7.765 0-14.083-6.318-14.083-14.083Z"
      />
      <path
        fill="url(#d)"
        d="M29.5 12.382c-5.86 0-10.626 4.766-10.626 10.626 0 5.859 4.767 10.626 10.626 10.626 5.86 0 10.626-4.767 10.626-10.626 0-5.86-4.767-10.626-10.626-10.626Zm0 16.059a5.44 5.44 0 0 1-5.433-5.433 5.44 5.44 0 0 1 5.433-5.433 5.44 5.44 0 0 1 5.433 5.433A5.44 5.44 0 0 1 29.5 28.44Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={28.438}
        x2={30.315}
        y1={21.624}
        y2={24.663}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={13.644}
        x2={41.669}
        y1={8.85}
        y2={54.206}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={23.788}
        x2={33.883}
        y1={15.569}
        y2={31.907}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)